<script lang="ts" setup>
import { reactive } from 'vue'
import { SLUG_CATEGORY_NEWS } from '~/resources/news'
import type { NewsData } from '~/composables/news/interface'
import { useNews } from '~/composables/news/use-news'
import NewsItem from '~/components/common/news/news-item.vue'
import Pagination from '~common/pagination.vue'
import LoadingSpin from '~common/loading-spin.vue'
import NewsNoData from '~/components/desktop/pages/news/news-no-data.vue'

const { fetchAllCategoryData, totalPost, postsPerPage, currentPage, handlePage, isLoading } = useNews()
const dataNews = reactive<NewsData[]>([])

const weeklyNewsSlug = SLUG_CATEGORY_NEWS.SOI_KEO
fetchAllCategoryData(dataNews, 0, postsPerPage.value, weeklyNewsSlug)
</script>
<template>
  <LoadingSpin v-if="isLoading && !dataNews[0]?.data" />
  <div v-else-if="dataNews[0]?.data" class="weekly-news-list">
    <div v-for="item in dataNews[0]?.data" :key="item.slug">
      <NewsItem :item="item" :categoryName="dataNews[0]?.category.name" />
    </div>
  </div>
  <NewsNoData v-else />
  <div v-if="totalPost > postsPerPage" class="pagination-news">
    <Pagination
      :total="totalPost"
      :page="currentPage"
      :itemPerPage="postsPerPage"
      :margin="1"
      :pageRange="4"
      :rangeIntervalPagBar="3"
      :reset="true"
      scrollToSection="#weekly-news"
      @changePage="handlePage($event, dataNews, weeklyNewsSlug)"
    />
  </div>
</template>
<style scoped lang="scss">
@import '~scssAsset/desktop/pages/news/news-weekly.scss';
</style>
